import React from "react";
import SVG from "react-inlinesvg";
import BetaChip from "../reusable/betaChip";
import NewChip from "../reusable/newChip";

interface NavLinkProps {
  badgeCount: number;
  classes: string;
  dataMethod: string;
  icon: string;
  iconImage: string;
  isBeta?: boolean;
  isSelectedFunction: any;
  label: string;
  location: string;
  handleClick?: () => void;
  selectedUrlPrefix: string;
  url: string;
}

export default class NavLink extends React.Component<NavLinkProps, any> {
  static defaultProps = {
    badgeCount: null,
    classes: "",
    dataMethod: null,
    icon: "",
    iconImage: "",
    isSelectedFunction: null,
    location: null,
    selectedUrlPrefix: null,
  };

  render() {
    return (
      <a
        id={`${this.props.label.toLowerCase().replace(/\s/g, "-")}-link`}
        className={this.getClasses()}
        data-method={this.props.dataMethod}
        data-testid={`${this.props.label} link`}
        href={this.props.url}
        onClick={this.props.handleClick}
      >
        {this.renderIcon()}

        <span className="text">{this.props.label}</span>
        {this.renderBadgeCount()}
        {this.renderBeta()}
      </a>
    );
  }

  renderIcon = () => {
    if (this.props.iconImage.length > 0) {
      return (
        <SVG
          src={this.props.iconImage}
          loader={<div className="nav-icon-placeholder" />}
        >
          <div className="nav-icon-placeholder" />
        </SVG>
      );
    }
    return <i className={this.props.icon} />;
  };

  renderBeta = () => {
    if (this.props.isBeta) {
      return <BetaChip />;
    }
    return null;
  };

  renderBadgeCount = () => {
    if (this.props.badgeCount > 0) {
      return <div className="notification">{this.props.badgeCount}</div>;
    }

    return null;
  };

  getClasses = () => {
    let selected;

    if (this.props.isSelectedFunction) {
      selected = this.props.isSelectedFunction(this.props.location);
    } else if (this.props.selectedUrlPrefix) {
      selected = this.props.location.startsWith(this.props.selectedUrlPrefix);
    } else {
      selected = this.convertUrl(this.props.url) === this.props.location;
    }

    return this.props.classes + (selected ? " current" : "");
  };

  convertUrl = (url) => {
    return url.split("?")[0];
  };
}
